import React from 'react';
import { useTranslation } from 'react-i18next';
import { SwitchContent } from './SwitchContent';

export const Sale = () => {
  const { t } = useTranslation();

  return (
    <SwitchContent
      texts={[
        t('premium-purchase-plan.header.strip.money_back'),
        t('premium-purchase-plan.header.sale.limited_time', { percent: 50 }),
      ]}
    />
  );
};
